import HOST_API from 'constants/HOST_API';

import React from 'react';
import Recoil from 'recoil';
import CryptoJS from 'crypto-js';
import useFetch from './useFetch';

export default function useBldsugrExistDate(props) {
  const onRequest = useFetch(HOST_API, 'V100/bldsugr/exist/date');

  const requestBldsugrExistDate = React.useCallback((parameters, callback) => {
    const {
      patient_no,
      search_start_time,
      search_end_time,
      search_type = 'D',
    } = parameters;

    if (!patient_no) return;

    const onReceive = (res) => {
      if (+res.res_code === 200) {
        callback && callback(true, res.data, parameters);
      } else {
        callback && callback(false, { message: res?.res_msg });
      }
    };
    const onCatch = (err) => {
      callback && callback(false, { messgae: '서버에 연결할 수 없습니다.' }, parameters);
    };
    const onExpire = (abort) => {
      abort('Timeout');
      callback && callback(false, { message: '서버가 응답하지 않습니다.' }, parameters);
      return true;
    };

    onRequest({
      parameters: {
        patient_no,
        search_start_time,
        search_end_time,
        search_type,
      },
      timeout: 6000,
      events: {
        onReceive,
        onExpire,
        onCatch,
      }
    });
  }, [onRequest]);

  const onBldsugrExistDate = React.useCallback((data, callback) => (parameters) => {
    requestBldsugrExistDate({ ...parameters, ...data }, callback);
  }, [requestBldsugrExistDate]);

  return {
    requestBldsugrExistDate,
    onBldsugrExistDate,
  };
}
